/**
 * 工具类.
 */
import { Message } from 'element-ui'

var class2type = {}
'Boolean Number String Function Array Date RegExp Object Error'.split(' ').forEach(function(e, i) {
  class2type['[object ' + e + ']'] = e.toLowerCase()
})

//当然为了兼容IE低版本，forEach需要一个polyfill，不作细谈了。
function _typeof(obj) {
  if (obj == null) {
    return String(obj)
  }
  return typeof obj === 'object' || typeof obj === 'function'
    ? class2type[class2type.toString.call(obj)] || 'object'
    : typeof obj
}

//获取字符串长度（汉字算两个字符，字母数字算一个）
function getByteLen(val) {
  var len = 0
  for (var i = 0; i < val.length; i++) {
    var a = val.charAt(i)
    if (a.match(/[^\x00-\xff]/gi) != null) {
      len += 2
    } else {
      len += 1
    }
  }
  return len
}

// 过滤数组中重复元素，返回新数组
function unique(arr) {
  var tmp = []
  for (var i in arr) {
    // 该元素在tmp内部不存在才允许追加
    if (tmp.indexOf(arr[i]) === -1) {
      tmp.push(arr[i])
    }
  }
  return tmp
}

// 判断object/json 是否为空
function isEmptyObject(e) {
  var t
  for (t in e) {
    return !1
  }
  return !0
}

const tip = (msg, { type = 'error', duration = 3000, ...rest } = {}, cb) => {
  Message({
    message: msg,
    type,
    duration,
    ...rest
  })

  if (cb) {
    setTimeout(() => cb(), duration)
  }
}

const deepClone = obj => {
  let clone = Object.assign({}, obj)
  Object.keys(clone).forEach(key => (clone[key] = typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key]))
  return Array.isArray(obj) ? ~(clone.length = obj.length) && Array.from(clone) : clone
}

const equals = (a, b) => {
  if (a === b) return true
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime()
  if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b
  if (a === null || a === undefined || b === null || b === undefined) return false
  if (a.prototype !== b.prototype) return false
  let keys = Object.keys(a)
  if (keys.length !== Object.keys(b).length) return false
  return keys.every(k => equals(a[k], b[k]))
}

const groupBy = (arr, fn) =>
  arr.map(typeof fn === 'function' ? fn : val => val[fn]).reduce((acc, val, i) => {
    acc[val] = (acc[val] || []).concat(arr[i])
    return acc
  }, {})

const resetData = obj => {
  // const typesMap = { string: '', array: [], obj: {} };
  for (let key in obj) {
    // obj[key] = typesMap[_typeof(obj[key])];
    if (_typeof(obj[key]) === 'array') {
      obj[key] = []
    } else if (_typeof(obj[key]) === 'string') {
      obj[key] = ''
    } else if (_typeof(obj[key]) === 'object') {
      obj[key] = {}
    }
  }
}
const comdify = (num, type = 'int') => {
  // 增加千位符
  let reg = type === 'int' ? /[^\d]/g : /[^\d*\.]/g
  let res = num
    .toString()
    .replace(reg, '')
    .match(/^\d*(\.?\d{0,2})/g)[0]
    .replace(/\d+/, function(n) {
      // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
        return $1 + ','
      })
    })
  return res
}
const delcommafy = num => {
  //去除千分位中的‘，’
  num = num.toString()
  num = num.replace(/,/g, '')
  return num
}

const isDate = obj => obj instanceof Date && !isNaN(obj.getTime())

const filterDate = data => {
  return data.reduce((acc, val) => {
    acc = acc.filter(item => !(item[0] >= val[0] && item[1] <= val[1]))
    return [...acc, val]
  }, [])
}

const sortDate = data => {
  return data
    .map((item, i) => ({ date: item[1], i }))
    .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0))
    .map(item => data[item.i])
}

const uniqueDate = data => {
  return data.reduce((acc, val) => {
    if (!isDate(new Date(val[0])) || !isDate(new Date(val[1]))) return acc

    if (!acc.find(item => item[0] === val[0] && item[1] === val[1])) {
      return [...acc, val]
    }
    return acc
  }, [])
}

const compose = (...fns) => fns.reduce((a, b) => (...args) => a(b(...args)))

const availableDate = compose(
  filterDate,
  sortDate,
  uniqueDate
)

const mgn = (a, b) => (b !== 0 ? mgn(b, a % b) : a)

const getScale = (a, b) => {
  if (!b) {
    ;[a, b] = a.split('*')
  }
  const max = mgn(a, b)
  return `${a / max}:${b / max}`
}

const amountUnit = value => {
  value = value.toString().match(/^\d*/g)[0]
  return value.length < 5 ? '' : value.length < 6 ? '万' : value.length < 7 ? '十万'  : value.length < 8 ? '百万' : value.length < 9 ? '千万' : value.length < 10 ? '亿' : ''
}

async function errorCaptured (asyncFunc) {
  try {
    const res = await asyncFunc()
    return [null, res]
  } catch (e) {
    return [e, null]
  }
}

function dataFilter (date) {
  let arr = []
  date.forEach(time => {
    let temp = []
    time.time.forEach(t => {
      if (t.length === 1) {
        temp.push(t < 10 ? ['0' + t, '0' + (parseInt(t) + 1)] : [t + '', parseInt(t) + 1 + ''])
      } else {
        temp.push(
          t.map((v, i) => {
            if (i === 1) {
              v = parseInt(v) + 1
            }
            return v < 10 ? '0' + parseInt(v) : v + ''
          })
        )
      }
    })
    arr.push({
      date: time.date,
      time: temp
    })
  })
  return arr
}

const loadImage = file => {
  return new Promise((resolve, reject) => {
    const URL = window.URL || window.webkitURL
    const image = new Image()
    image.src = /^http\S+\.(jpeg|png|jpg|gif|mp4)/.test(file) ? file : URL.createObjectURL(file)
    image.onload = function () {
      resolve(this)
    }
    image.onerror = reject
  })
}
function hexify(color) {
  var values = color
    .replace(/rgba?\(/, '')
    .replace(/\)/, '')
    .replace(/[\s+]/g, '')
    .split(',');
  var a = parseFloat(values[3] || 1),
      r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
      g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
      b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
  return "#" +
    ("0" + r.toString(16)).slice(-2) +
    ("0" + g.toString(16)).slice(-2) +
    ("0" + b.toString(16)).slice(-2);
}
export {
  getByteLen,
  unique,
  isEmptyObject,
  _typeof,
  tip,
  deepClone,
  equals,
  groupBy,
  resetData,
  comdify,
  delcommafy,
  availableDate,
  mgn,
  getScale,
  amountUnit,
  errorCaptured,
  dataFilter,
  loadImage,
  hexify
}
